module.exports = __webpack_public_path__ + "static/Home-features-person-mobile-3968266281f2c67efd095ce68eae29aa.png";